import { render, staticRenderFns } from "./CanvasSelectionToolbar.vue?vue&type=template&id=5efe1471&scoped=true"
import script from "./CanvasSelectionToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasSelectionToolbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanvasSelectionToolbar.vue?vue&type=style&index=0&id=5efe1471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe1471",
  null
  
)

export default component.exports